import React from 'react';
import Spinner from '../spinner';
import type { SearchDropdownProps } from '../interfaces';
import SearchResultCard from './SearchResultCard';
import {
  formatSearchPrice,
  getSearchResultDetails,
  getSearchResultImage,
} from './searchBar.helpers';

const SearchDropdown: React.FC<SearchDropdownProps> = ({
  error,
  isOpen,
  materialImages,
  results,
  status,
  onClose,
  onResultClick,
}) => {
  const resultLabel = results.length === 1 ? 'result' : 'results';

  return (
    <>
      <div className={`search-backdrop ${isOpen ? 'open' : 'closed'}`} onClick={onClose} />

      <div
        id="catalog-search-results"
        className={`custom-dropdown ${isOpen ? 'open' : 'closed'}`}
        role="dialog"
        aria-label="Catalog search results"
        onWheel={(event) => event.stopPropagation()}
        onTouchMove={(event) => event.stopPropagation()}
      >
        {status !== 'loading' && !error && results.length > 0 && (
          <div className="dropdown-header">
            <span>Search results</span>
            <small>{results.length} {resultLabel}</small>
          </div>
        )}

        {status === 'loading' ? (
          <div className="search-state">
            <div className="spinner-wrapper"><Spinner /></div>
            <span>Searching catalog</span>
          </div>
        ) : error ? (
          <div className="dropdown-item error">{error}</div>
        ) : results.length > 0 ? (
          <div className="search-results-list">
            {results.map((product) => (
              <SearchResultCard
                key={product.id}
                product={product}
                imageUrl={getSearchResultImage(materialImages, product.id)}
                price={formatSearchPrice(product.price)}
                details={getSearchResultDetails(product)}
                onResultClick={onResultClick}
              />
            ))}
          </div>
        ) : (
          <div className="search-state search-state--empty">
            <strong>Nothing found</strong>
            <span>Try a product type, material, or shorter search term.</span>
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(SearchDropdown);
